/**
 * Created by XuQiang on 2017/5/25.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { routerRedux } from 'dva/router';
import { OPEN_LOGIN, PATH_HOME } from '../../utils/constants';

export default ({ intl, dispatch, loginData }) => {
  const { domainName, newPassword } = loginData;
  return (
    <div className="fix-resetting">
      <div className="resetting-cont">
        <div className="resetting-title">
          <FormattedMessage id="index_reset_password" />
        </div>
        <div className="resetting-type">
          <input
            type="password"
            value={newPassword.pwd}
            onChange={v =>
              dispatch({
                type: 'login/setNewPassword',
                newPassword: { ...newPassword, pwd: v.target.value, tips: '' }
              })
            }
            placeholder={intl.formatMessage({ id: 'index_password_prompt' })}
          />
        </div>
        <div className="resetting-type">
          <input
            type="password"
            value={newPassword.pwd1}
            onChange={v =>
              dispatch({
                type: 'login/setNewPassword',
                newPassword: { ...newPassword, pwd1: v.target.value, tips: '' }
              })
            }
            placeholder={intl.formatMessage({ id: 'index_password_conform' })}
          />
        </div>
        <p className="resetting-case">{newPassword.tips}</p>
        {/*提示信息*/}

        <div className="resetting-btn">
          <a
            onClick={() => {
              if (
                !/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,}$/g.test(
                  newPassword.pwd
                ) ||
                newPassword.pwd !== newPassword.pwd1
              ) {
                dispatch({
                  type: 'login/setNewPassword',
                  newPassword: {
                    ...newPassword,
                    tips: intl.formatMessage({ id: 'password_error_prompt' })
                  }
                });
                return;
              }
              dispatch({ type: 'login/reSetPassword', pwd: newPassword.pwd });
            }}
          >
            <FormattedMessage id="index_save_continue" />
          </a>
        </div>
        <div className="jump_link">
          <a
            className="lf"
            onClick={() => {
              dispatch(routerRedux.push(`${PATH_HOME}${domainName}`));
              dispatch({ type: 'login/setDivType', divType: OPEN_LOGIN });
            }}
          >
            <FormattedMessage id="index_login2" />
          </a>
          {/* <a className="lr" onClick={() => {
            dispatch(routerRedux.push(`${PATH_HOME}${domainName}`));
            dispatch({type: 'login/setDivType', divType: OPEN_SIGN})
          }}>
            <FormattedMessage id='index_register_account'/>
          </a> */}
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/login/ResetPassword.js